document.addEventListener('DOMContentLoaded', function() {
  const voiceSwiper = new Swiper('.voice-swiper', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.voice-button-next',
      prevEl: '.voice-button-prev',
    },
    breakpoints: {
      750: {
        slidesPerView: 4,
        spaceBetween: 30,
        slidesPerGroup: 1,
      }
    },
  });
});